<template>
  <a-cascader @change="changeXzc" :changeOnSelect="changeOnSelect" :expandTrigger="expandTrigger" v-model="defaultValue" :disabled="disableds" :options="options" :placeholder="placeholder" />
</template>
<script>
import { getAction } from '@/api/manage'

export default {
  name: 'OrgSelect',
  props: {
    category: String,
    placeholder: String,
    value:String,
    csh:Boolean,
    pcd:String,
    jectValue:String,
    triggerChange: Boolean,
    disabled:{
      type:Boolean,
      default: false
    },
    expandTrigger:{
      type:String,
      default:'click'
    },
    changeOnSelect:{
      type:Boolean,
      default:false
    },
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    }
  },
  watch: {
    'value': function (val) {
      this.$nextTick(() => {
        if(val=="" || val==undefined || val == null){
          this.defaultValue = [];
        }else{
          if(this.childrenCode==""){
              for(let i=0;i<(val.length-this.pcd.length)/3;i++){
                this.defaultValue.push(val.substr(0,(i+1)*3+this.pcd.length));
              }
            }else{
              for(let i=0;i<(val.length-this.childrenCode.length)/3;i++){
                this.defaultValue.push(val.substr(0,(i+1)*3+this.childrenCode.length));
              }
            }
        }
      })
    }
  },
  data() {
    return {
      options: [],
      defaultValue:[],
      disableds:false,
      childrenCode:""
    };
  },
  created(){
    this.$nextTick(() => {
      if(this.pcd!=undefined && this.pcd!=null && this.pcd!=''){
        this.initAreaData(this.value,this.pcd);
      }
    })
  },
  methods: {
    changeXzc(value) {
      var val='';
      if(value.length>0){
        val=value[value.length-1];
      }
      if(this.triggerChange){
        this.$emit('change', val);
      }else{
        this.$emit('input', val);
      }
    },
    initAreaData(record,pCode,childrenCode){
      let taht = this;
      if(childrenCode!=undefined){
        taht.childrenCode = childrenCode;
      }
      
      getAction('/sys/category/loadTreeRoot?async=false&pcode='+pCode,{}).then((res)=>{
        let orgList = res.result;
        orgList = this.getchildren(orgList);
        
        if(childrenCode==undefined){
          taht.options = orgList;
        }else{
          for(var i=0;i<orgList.length;i++){
            if(orgList[i].code == childrenCode){
              taht.options = [orgList[i]];
            }
          }
        }
        if(taht.defaultValue.length==0){
          taht.defaultValue = [];
          if(record==""||record==null||typeof record=='undefined'){
            taht.defaultValue = [];
          }else{
            if(childrenCode==undefined){
              for(let i=0;i<(record.length-pCode.length)/3;i++){
                taht.defaultValue.push(record.substr(0,(i+1)*3+pCode.length));
              }
            }else{
              for(let i=0;i<(record.length-childrenCode.length)/3;i++){
                taht.defaultValue.push(record.substr(0,(i+1)*3+childrenCode.length));
              }
            }
          }
        }
        
        taht.disableds = taht.disabled;
      })
    },
    getchildren(orgList){
      for(var i = 0;i<orgList.length;i++){
        orgList[i].value = orgList[i].code;
        orgList[i].label = orgList[i].title;
        if(orgList[i].children != null || orgList[i].children !=undefined){
          this.getchildren(orgList[i].children);
        }else{
          orgList[i].children = undefined;
        }
      }
      return orgList;
    }
  },
};
</script>